export default {
  title: 'Sign Up Here',
  subTitle: 'to get the latest news and updates',
  button: 'Join',
  error: 'Please provide a valid email address',
  thankYou: 'Thank You!'
};
